export interface CompiledFromReference {
    source: string;
    reference: string;
}

export interface CompiledFromSetting {
    filterValue: string;
    description: string;
    pattern: string;
    patternMessage: string;
    size: number;
}
export const compiledFromSettings: CompiledFromSetting[] = [
    {
        filterValue: 'PLAN',
        description: 'plan',
        pattern: '(^([D][P]|[P]|[D])\\d{1,8})|(^$)',
        patternMessage:
            "The plan from which the plan to be lodged was compiled from - format is [Plan Type][PlanNumber] where [Plan Type] is 'DP', 'D' or 'P'.",
        size: 10
    },
    {
        filterValue: 'FIELD',
        description: 'field record',
        pattern: '(\\d{1,8})|(^$)',
        patternMessage: 'The field record from which the plan to be lodged was compiled from.',
        size: 8
    },
    {
        filterValue: 'TITLE',
        description: 'title',
        pattern: '(^([E][C]|[E][T]|[G][C]|[G][T]|[L][G]|[L][R]|[C][T]|[R][G]|[S][P])\\d{1,8}-\\d{1,8}[a-zA-Z]{0,1})|(^$)',
        patternMessage:
            // eslint-disable-next-line max-len
            "The title from which the plan to be lodged was compiled from - format is [Title Prefix][Title Volume]-[Title Folio][Title Suffix] where [Title Prefix] can be 'EC', 'ET' ,'GC', 'GT', 'LG' ,'LR' ,'CT' ,'RG' ,'SP'.",
        // eslint-enable-next-line max-len
        size: 20
    }
];
